module.exports = __webpack_public_path__ + "assets/images/TTD20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/TTD20.png
// module id = 1435
// module chunks = 1